/* Textos de un descuento de evento: puede ser un PORCENTAJE (10%) o un MONTO FIJO en dolares ($10 por entrada o por compra).
   `d` es lo que devuelve el backend (tipo_descuento, porcentaje, monto_descuento, monto_por) o lo guardado en
   sessionStorage ("descuentoLinkPublico"). Sin tipo_descuento (descuentos de antes) es un porcentaje. */

export const esDescuentoMonto = (d) => d?.tipo_descuento === "monto"

const dolares = (n) => `$${(Number(n) || 0).toFixed(2)}`
const pct = (n) => `${Number(n) % 1 === 0 ? Number(n) : Number(n).toFixed(2)}%`

// "$10.00 por entrada" / "$10.00 por compra" / "10%"
export const valorDescuento = (d) =>
  esDescuentoMonto(d) ? `${dolares(d.monto_descuento)} ${d.monto_por === "compra" ? "por compra" : "por entrada"}` : pct(d?.porcentaje)

// "10% de descuento" / "$10.00 de descuento por entrada"
export const textoDescuento = (d) =>
  esDescuentoMonto(d)
    ? `${dolares(d.monto_descuento)} de descuento ${d.monto_por === "compra" ? "por compra" : "por entrada"}`
    : `${pct(d?.porcentaje)} de descuento`

// Cuanto se descuenta con un monto fijo (igual que el backend: calcularDescuentoMonto): por entrada cobrada o una vez por compra, sin pasar del total
export const montoDescontado = ({ bruto, montoUnitario, montoPor, entradas }) => {
  const redondear = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100
  const unidades = montoPor === "compra" ? 1 : Math.max(0, Math.floor(Number(entradas) || 0))
  return Math.max(0, Math.min(redondear((Number(montoUnitario) || 0) * unidades), redondear(Number(bruto) || 0)))
}
